/* eslint-disable react/jsx-no-bind */
import {
  Conversation,
  LiveAnswersClient,
  LiveAnswersMessage,
  ToolCall,
} from '@stripe-internal/conversations-client';
import {useUniversalHelpDotComDesign} from '../../FeatureFlagsProvider';
import {LiveAnswersRowDotCom} from './LiveAnswersRowDotCom';
import {LiveAnswersRowAssistant} from './LiveAnswersRowAssistant';

type Props = {
  // We need to work to remove the Conversation prop as it is not
  // meant to be referenced within the Chat directory components.
  // It's included here for backwards compatibility with the existing
  // Assistant Live Answers Response, which is referencing it.
  conversation?: Conversation;
  liveAnswersMessage: LiveAnswersMessage;
  liveAnswersClient: LiveAnswersClient;
  onDoneStreaming: (_onDoneData: {
    content: string;
    toolCalls?: ToolCall[];
    answerType?: 'unanswerable' | 'answerable';
  }) => void;
  onError: (error?: string) => void;
  isDone?: boolean;
};

export const LiveAnswersRow = ({
  conversation,
  liveAnswersMessage,
  liveAnswersClient,
  onDoneStreaming,
  onError,
  isDone,
}: Props) => {
  const dotComDesigns = useUniversalHelpDotComDesign();

  if (dotComDesigns) {
    return (
      <LiveAnswersRowDotCom
        liveAnswersMessage={liveAnswersMessage}
        liveAnswersClient={liveAnswersClient}
        onDoneStreaming={onDoneStreaming}
        onError={onError}
      />
    );
  }
  return (
    <LiveAnswersRowAssistant
      conversation={conversation}
      liveAnswersMessage={liveAnswersMessage}
      liveAnswersClient={liveAnswersClient}
      onDoneStreaming={onDoneStreaming}
      onError={onError}
      isDone={isDone}
    />
  );
};
